import { TButton } from "../../../entities/content";
import { GlobalDataLayerService } from "../global-data-layer-service";
import { ClickElementTypes, EventActions } from "../../../utility/constants";

export function sendBurgerButtonDataLayerEvent(menu: TButton): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.MORE_CLICK,
    {
      componentClick: {
        clickElementId: menu.id,
        clickElementName: menu.text,
        targetElement: "level1_drawer",
        clickElementType: ClickElementTypes.Button,
      },
    },
  );
}
